import { render, staticRenderFns } from "./gameover.vue?vue&type=template&id=8a349cba&scoped=true"
import script from "./gameover.vue?vue&type=script&lang=js"
export * from "./gameover.vue?vue&type=script&lang=js"
import style0 from "./gameover.vue?vue&type=style&index=0&id=8a349cba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a349cba",
  null
  
)

export default component.exports